import { reactive } from "vue";
import { getSession, type ApiPrincipal } from "../api";

export interface SessionState {
  checked: boolean;
  authenticated: boolean;
  principal: ApiPrincipal | null;
}

const state = reactive<SessionState>({ checked: false, authenticated: false, principal: null });
let pending: Promise<SessionState> | undefined;

export function sessionState(): SessionState {
  return state;
}

export async function ensureSession(force = false): Promise<SessionState> {
  if (state.checked && !force) return state;
  if (pending && !force) return pending;
  pending = getSession().then((result) => {
    state.checked = true;
    state.authenticated = result.authenticated;
    state.principal = result.principal;
    return state;
  }).catch((error) => {
    state.checked = true;
    state.authenticated = false;
    state.principal = null;
    throw error;
  }).finally(() => {
    pending = undefined;
  });
  return pending;
}

export function clearSession(): void {
  state.checked = true;
  state.authenticated = false;
  state.principal = null;
}

export function hasRole(role: "customer" | "operator" | "admin" | "superadmin"): boolean {
  return state.principal?.roles.includes(role) ?? false;
}

export function isAdministrator(): boolean {
  return hasRole("admin") || hasRole("operator");
}

export function isSuperAdministrator(): boolean {
  return hasRole("superadmin");
}
